import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css'
import './theme/index.css'
import store from './store'
import i18n from './lang'
import axios from 'axios'
import VueGtag from 'vue-gtag'
import Meta from 'vue-meta'

Vue.use(VueGtag, {
  config: {
    id: 'G-852E0ERRL3',
    pageTrackerTemplate (to) {
      return {
        page_title: 'findchip',
        page_path: to.path
      }
    }
  }
}, router)

Vue.use(Meta)

axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

axios.defaults.baseURL = process.env.VUE_APP_AXIOS
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
